import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import DOWN_ARROW from "../../../assets/img/DOWN-ARROW.svg";
import "./CommonQuestionsInstallation.scss";
import content from "../../Pages/CommonQuestions/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const CommonQuestionsInstallation = () => {
  const { language } = useLanguageCtx();
  
  return (
		<div
			className="all-width pb-80 mt-80"
			style={{ backgroundColor: "#F0F3F7" }}
		>
			<div className="max-width">
				<h3 className="t3 pt-40 pb-10">
					{content[language].instalacion_title}
				</h3>
				<div>
					<Accordion>
						<AccordionSummary expandIcon={<img src={DOWN_ARROW} alt="Arrow" />}>
							<h4 className="commonQuestionsInstallation-accordion-bold-text no-space pt-10 pb-10">
								{content[language].pregunta_1}
							</h4>
						</AccordionSummary>
						<AccordionDetails>
							{content[language].respuesta_1.map((text, i) => (
								<p
									className="body-16 no-space commonQuestionsInstallation--solution"
									key={`${content[language].pregunta_1}-${i}`}
								>
									{text}
								</p>
							))}
						</AccordionDetails>
					</Accordion>
					<Accordion>
						<AccordionSummary expandIcon={<img src={DOWN_ARROW} alt="Arrow" />}>
							<h4 className="commonQuestionsInstallation-accordion-bold-text no-space pt-10 pb-10">
								{content[language].pregunta_2}
							</h4>
						</AccordionSummary>
						<AccordionDetails>
							<p className="body-16 no-space commonQuestionsInstallation--solution">
								{content[language].respuesta_2}
							</p>
						</AccordionDetails>
					</Accordion>
					<Accordion>
						<AccordionSummary expandIcon={<img src={DOWN_ARROW} alt="Arrow" />}>
							<h4 className="commonQuestionsInstallation-accordion-bold-text no-space pt-10 pb-10">
								{content[language].pregunta_3}
							</h4>
						</AccordionSummary>
						<AccordionDetails>
							<p className="body-16 no-space commonQuestionsInstallation--solution">
								{content[language].respuesta_default}
							</p>
						</AccordionDetails>
					</Accordion>
					<Accordion>
						<AccordionSummary expandIcon={<img src={DOWN_ARROW} alt="Arrow" />}>
							<h4 className="commonQuestionsInstallation-accordion-bold-text no-space pt-10 pb-10">
								{content[language].pregunta_2}
							</h4>
						</AccordionSummary>
						<AccordionDetails>
							<p className="body-16 no-space commonQuestionsInstallation--solution">
								{content[language].respuesta_default}
							</p>
						</AccordionDetails>
					</Accordion>
					<Accordion>
						<AccordionSummary expandIcon={<img src={DOWN_ARROW} alt="Arrow" />}>
							<h4 className="commonQuestionsInstallation-accordion-bold-text no-space pt-10 pb-10">
								{content[language].pregunta_3}
							</h4>
						</AccordionSummary>
						<AccordionDetails>
							<p className="body-16 no-space commonQuestionsInstallation--solution">
								{content[language].respuesta_default}
							</p>
						</AccordionDetails>
					</Accordion>
				</div>
			</div>
		</div>
	);
};

export default CommonQuestionsInstallation;
